import { getPianoAccount } from '@/app_actions/Piano/pianoAccountActions';
import type { Tinypass } from '@/app_lib/types/tinypass';
import type { EventData } from '@/main/lib/services/Gtm/entities';

interface PianoTemplateTrackingEvent {
  eventName: string;
  type: string;
  params: {
    contentPlacement: string;
    displayMode: string;
    clickText: string;
    clickType: 'close' | 'cta button' | 'expand' | 'collapse' | 'sign in link';
  };
}

export const checkPianoAccountExists = async (email: string, tp: Tinypass) => {
  const loggedInUser = tp.pianoId.getUser();
  if (loggedInUser) {
    return true;
  }

  try {
    const user = await getPianoAccount(email);
    return user !== null;
  } catch (_error) {
    return false;
  }
};

export const pianoTemplateTrackingEvent = (
  event: PianoTemplateTrackingEvent,
  sendEventOnConsent: (eventData: EventData) => void,
) => {
  switch (event.type) {
    case 'nlTemplateClick': {
      const { contentPlacement, displayMode, clickText, clickType } = event.params;

      const templateTrackingPayload = {
        displayMode,
        eventAction: 'newsletter template clicked',
        eventCategory: 'piano template',
        eventLabel: 'user clicked on newsletter template',
        manualClickText: clickText,
        manualClickType: clickType,
        manualContentPlacement: contentPlacement,
      };

      sendEventOnConsent(templateTrackingPayload);
      break;
    }
    default:
      break;
  }
};
